import HttpClient from "../../../core/api/httpClient";
import { QualityChecksSummary } from "../model/qualityCheckSummaryDto";

const baseUrl = '/api/statistics';

export default class StatisticsApi {
    static async getQualityCheckStatusesByDates(start: string, end: string): Promise<QualityChecksSummary[]>{
        const response = await HttpClient.get(`${baseUrl}/statuses?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`);
        return await response.json();
    }
}
